module.exports = __webpack_public_path__ + "static/media/i3.070cdc9f.svg";